import React from 'react';
import clsx from 'clsx';
import styles from './GlassPanel.module.css';

interface GlassPanelProps {
  children: React.ReactNode;
  className?: string;
  padding?: 'sm' | 'md' | 'lg' | 'xl';
}

const GlassPanel: React.FC<GlassPanelProps> = ({ children, className, padding = 'md' }) => {
  return (
    <div className={clsx(styles.panel, styles[`padding-${padding}`], className)}>{children}</div>
  );
};

export default GlassPanel;
